import { connect } from 'react-redux';

import first from 'lodash/first';

import ConfirmationModal from './confirm_create_html_package_modal.jsx';

import {
  showModal,
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  setContentItemAsset,
  createContentItemFromAsset
} from 'zoomforth_codesbane_editor/action_creators/content.js';

import {
  uploadFileToSingletonContentSection
} from 'zoomforth_codesbane_editor/action_creators/sections.singleton.js';

import selectFilesWithOs from 'zoomforth_zfutils/select_files_with_os.js';

import SelectMediaFromLibrary 
  from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/select_media_from_library_container.jsx';

const mapStateToProps = () => {
  return {};
};


const mapDispatchToProps = (dispatch, { section }) => (
  {
    onRequestClose: ()=> { 
      dispatch(closeModal()); 
    },
    onUploadClick: ()=> { 
      selectFilesWithOs({ multiple: false, accept: ['.zip'] }).done((files) => {
        dispatch(uploadFileToSingletonContentSection(section, first(files), { forceAssetType: 'html_package' }));
        dispatch(closeModal());
      });
    },
    onSelectFromMediaLibraryClick: ()=> {
      dispatch(closeModal()); 
      dispatch(showModal(
        SelectMediaFromLibrary, 
        { 
          multiple: false,
          enabledMediaTypes: ['html_package'],
          enabledMediaWarningMsg: 'You may only select HTML Packages for this section',
          onAssetsSelectDone: (assets) => {
            const newHtmlPackageAsset = assets[0];

            if (section.singletonContentUuid) {
              dispatch(setContentItemAsset(section.singletonContentUuid, newHtmlPackageAsset));
            } else {
              dispatch(createContentItemFromAsset(section, newHtmlPackageAsset));
            }
          }
        }
      ));
    }
  }
);

const ConfirmCreateHtmlPackageForSectionModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmationModal);

ConfirmCreateHtmlPackageForSectionModal.editorModalName = 'ConfirmCreateHtmlPackageForSectionModal';

export default ConfirmCreateHtmlPackageForSectionModal;
